import { AuthService } from '@indigo-ag/ui-core';
import React from 'react';
import { useDispatch } from 'react-redux';

import { AuthActions } from 'store/features/auth/actions';
import { Login } from './Login';
import './styles.css';

export const LoginPage: React.FunctionComponent = (): JSX.Element => {
  /**
   * Store
   */
  const dispatch = useDispatch();

  const onSuccess = () => {
    AuthService.setReferrer('');
    dispatch(AuthActions.loginSuccess());
  };

  return (
    <div style={{ display: 'flex' }} className="soy-background login-container">
      <Login onAuthSuccess={onSuccess} />
    </div>
  );
};
